<script>
    import Share from "./Share.svelte";
    import Qr from "./Qr.svelte";
    import CopyUrl from "./CopyUrl.svelte";
    import { t } from "../../../lang/lang.js";

    export let qr;
    export let url;
    export let model_id;
    export let unsupported = false;
</script>

<Share {url}>
    <span slot="title">
        { t( 'widget.title_model') }
    </span>
    <div slot="left">
        Превью модельки {model_id}
    </div>
    <div slot="right">
        <div class="arsize_qr_note">
            { t(unsupported ? 'widget.unsupported_text' : 'widget.share_text') }
        </div>
        <Qr {qr} />
        <CopyUrl {url} />
    </div>
</Share>

<style>
    .arsize_qr_note {
        font-size: 16px;
        margin-bottom: 34px;
    }
</style>